import React from 'react';
import { pickerScopeCaption } from '../../../utils/accountPickerOptions';

/**
 * The one-line caption + toggle under an account picker (ONE_CHART_PLAN.md
 * OC-5): says what the default view holds and opens the whole chart on
 * request. Rendered only when the backend could resolve the basuppsättning;
 * otherwise the picker already shows everything and there is nothing to say.
 *
 * The words are the user's, not BAS's (UX_PLAN.md P5): "de vanligaste
 * kontona", and the clause about own and used accounts only once the company
 * has some. Typing in the picker searches the whole chart regardless — the
 * no-match text says so.
 */
export default function AccountPickerScope({
  showAll, onToggle, defaultCount, totalCount, hasCompanyAccounts = true, disabled = false, style,
}) {
  if (!totalCount || defaultCount >= totalCount) return null;
  const caption = pickerScopeCaption({ showAll, defaultCount, totalCount, hasCompanyAccounts });
  return (
    <div
      className="account-picker-scope"
      style={{ fontSize: '0.8125rem', color: 'var(--secondary, #717579)', marginTop: '0.375rem', ...style }}
    >
      {caption.text}{' '}
      <button
        type="button"
        className="btn btn-link p-0 align-baseline"
        style={{ fontSize: 'inherit', textDecoration: 'underline' }}
        onClick={onToggle}
        disabled={disabled}
        aria-pressed={showAll}
      >
        {caption.toggle}
      </button>
    </div>
  );
}
